<template>
	<section
		class="collapsible-section"
		:class="{ 'is-open': isOpen, 'is-static': !collapsible, 'is-collapsed': collapsible && !isOpen }"
		:style="sectionStyle"
	>
		<div class="section-viewport" :style="viewportStyle">
			<button
				v-if="collapsible"
				class="collapse-toggle"
				type="button"
				:aria-expanded="String(isOpen)"
				:aria-label="headerAriaLabel"
				@click="toggle"
			>
				<i class="bi" :class="isOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
			</button>

			<slot />
		</div>
	</section>
</template>

<script>
export default {
	name: 'CollapsibleSection',
	props: {
		title: {
			type: String,
			required: true,
		},
		collapsible: {
			type: Boolean,
			default: true,
		},
		initiallyOpen: {
			type: Boolean,
			default: false,
		},
		collapsedHeight: {
			type: Number,
			default: 72,
		},
	},
	data() {
		return {
			isOpen: this.initiallyOpen,
		};
	},
	computed: {
		headerAriaLabel() {
			return this.collapsible ? `Toggle ${this.title}` : `${this.title} section`;
		},
		sectionStyle() {
			return {
				'--collapsed-height': `${this.collapsedHeight}px`,
			};
		},
		viewportStyle() {
			if (!this.collapsible || this.isOpen) {
				return {};
			}
			return {
				maxHeight: `${this.collapsedHeight}px`,
			};
		},
	},
	watch: {
		initiallyOpen(nextValue) {
			this.isOpen = nextValue;
		},
	},
	methods: {
		toggle() {
			if (!this.collapsible) return;
			this.isOpen = !this.isOpen;
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/assets/main.scss';

.collapsible-section {
	position: relative;
	margin-bottom: 12px;
	width: 100%;

	.section-viewport {
		position: relative;
		overflow: visible;
		border-radius: 8px;
		max-width: 800px;
		margin: 0 auto;
		width: 100%;

		.collapse-toggle {
			position: absolute;
			top: 14px;
			right: 10px;
			z-index: 5;
			width: 30px;
			height: 30px;
			border-radius: 999px;
			border: 1px solid rgba($primary-color, 0.26);
			background: lighten($secondary-color, 4%);
			color: $primary-color;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
			transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.12s ease;

			&:hover:enabled {
				background: $secondary-color;
				border-color: rgba($primary-color, 0.4);
				transform: translateY(-1px);
			}

			&:focus-visible {
				outline: 2px solid rgba($primary-color, 0.45);
				outline-offset: 1px;
			}

		}
	}

	&.is-collapsed .section-viewport {
		overflow: hidden;
		border-bottom: 1px solid rgba($primary-color, 0.28);
		border-radius: 8px;
	}

	&.is-collapsed :deep(.hide-on-collapse) {
		display: none !important;
	}
}
</style>
